import { FunctionComponent } from 'react';

import { Form } from '@kanda-libs/ks-component-ts';
import { Button, Loader, Text } from '@kanda-libs/ks-design-library';

import { PaymentElement } from '@stripe/react-stripe-js';
import AcceptTermsInput from 'components/AcceptTermsInput';
import ActionRequired from 'components/ActionRequired';
import { formatToCurrency } from 'utils';

import useCardPaymentFormElements from './useCardPaymentFormElements';

import CardPaymentFormError from '../Error';
import CardPaymentFormLoader from '../Loader';

const CardPaymentFormElements: FunctionComponent = () => {
  const {
    form,
    onSubmit,
    isLoading,
    isSubmitting,
    showPropsError,
    disabled,
    amount,
    title,
    showActionRequired,
    titleClassName,
    onElementChange,
    customHeading,
  } = useCardPaymentFormElements();

  if (isLoading) return <CardPaymentFormLoader />;

  if (showPropsError) return <CardPaymentFormError />;

  return (
    <Form id="card-payment" form={form} onSubmit={onSubmit}>
      <div className={titleClassName}>
        {showActionRequired && <ActionRequired />}
        <Text className="text-20-24-em" text={title} />
      </div>
      {customHeading}
      <PaymentElement onChange={onElementChange} />
      <div className="mt-6 md:mt-8">
        <AcceptTermsInput />
      </div>
      <div className="flex flex-row justify-between mb-4 md:mb-6 text-16-20-em md:text-18-22-em">
        <span>Payment Amount:</span>
        <span className="text-neutral-800 text-18-22-em md:text-20-24-em">
          {formatToCurrency(amount)}
        </span>
      </div>
      <Button.Text
        submit
        left
        disabled={disabled}
        id="card-payment-pay-deposit"
        label={
          <div className="flex flex-row">
            <span className="my-auto mr-2">Make Payment</span>
          </div>
        }
        variant="gradient"
        icon="check"
        className="w-full"
      />
      <Loader isLoading={isSubmitting} />
    </Form>
  );
};

export default CardPaymentFormElements;
